import { MessageOutlined, QuestionCircleOutlined, ReadOutlined } from '@ant-design/icons';
import type { MenuItem } from '@lib/common';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { buildUserGuideUrl, FEEDBACK_FORM_URL, openExternalLink } from '../utils/help-links.util';

/** Help entries (Guide + Add Feedback) shared by the sidebars and the header. */
export const useHelpMenu = () => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();

  const helpLinks = useMemo<MenuItem[]>(
    () => [
      {
        key: 'help-guide',
        label: t('userGuide'),
        icon: <ReadOutlined />,
        onClick: () => openExternalLink(buildUserGuideUrl(locale)),
      },
      {
        key: 'help-feedback',
        label: t('addFeedback'),
        icon: <MessageOutlined />,
        onClick: () => openExternalLink(FEEDBACK_FORM_URL),
      },
    ],
    [locale, t],
  );

  const helpMenuItem = useMemo<MenuItem>(
    () => ({
      key: 'help',
      label: t('help'),
      icon: <QuestionCircleOutlined />,
      children: helpLinks,
    }),
    [helpLinks, t],
  );

  return { helpLabel: t('help'), helpLinks, helpMenuItem };
};
